function renewalDisplay(transaction = {}) {
  if (!transaction || Number(transaction.pricing_model?.type) !== 2) return null;
  const state = transaction.subscription_renewal;
  if (state?.status === 'active') return null;
  if (state?.status === 'cancelled') return {
    title: 'Renewal cancelled', cancelledAt: state.cancelledAt, paidThrough: state.paidThrough,
  };
  if (state?.status === 'inactive') return { title: 'Renewal inactive' };
  return { title: 'Renewal status unavailable', explanation: 'Refresh this transaction before cancelling.' };
}

function renewalDate(value) {
  if (!value || !Number.isFinite(Date.parse(value))) return '';
  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', month: 'short', day: 'numeric', year: 'numeric',
    hour: 'numeric', minute: '2-digit', timeZoneName: 'short',
  }).format(new Date(value));
}

module.exports = { renewalDisplay, renewalDate };
